// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"gesture-right"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M15 12.25H19.5C20.6046 12.25 21.5 11.3546 21.5 10.25C21.5 9.14543 20.6046 8.25 19.5 8.25H9.5L10.3514 4.41889C10.4409 4.01575 10.2735 3.599 9.92987 3.36991L9 2.75L3.28058 7.14955C2.78841 7.52815 2.5 8.11386 2.5 8.7348L2.5 16.8085C2.5 17.6693 3.05086 18.4336 3.86754 18.7058L9.95864 20.7362C10.8567 21.0356 11.8417 20.6643 12.3187 19.8466L14.7276 15.717C14.906 15.4112 15 15.0634 15 14.7093V12.25Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 12.25H19.5C20.6046 12.25 21.5 11.3546 21.5 10.25C21.5 9.14543 20.6046 8.25 19.5 8.25H9.5L10.3514 4.41889C10.4409 4.01575 10.2735 3.599 9.92987 3.36991L9 2.75L3.28058 7.14955C2.78841 7.52815 2.5 8.11386 2.5 8.7348L2.5 16.8085C2.5 17.6693 3.05086 18.4336 3.86754 18.7058L9.95864 20.7362C10.8567 21.0356 11.8417 20.6643 12.3187 19.8466L14.7276 15.717C14.906 15.4112 15 15.0634 15 14.7093V12.25Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const GestureRightIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'gesture-right',
    ref,
    icon: element,
  },
));

GestureRightIcon.displayName = 'GestureRightIcon';

export default GestureRightIcon;
